import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import Editor from "../components/Editor";

export default function EditPost() {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [content, setContent] = useState("");

  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/posts/getSinglePost/${id}`
    ).then((response) => {
      response.json().then((postInfo) => {
        setTitle(postInfo.title);
        setContent(postInfo.content);
        setImage(postInfo.image);
      });
    });
  }, []);

  async function updatePost(ev) {
    ev.preventDefault();
    // const data = new FormData();
    // data.set("title", title);
    // data.set("image", image);
    // data.set("content", content);

    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/posts/updatePost/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ title: title, content: content, image: image }),
        credentials: "include",
      }
    );
    if (response.ok) {
      setRedirect(true);
    }
  }

  if (redirect) {
    return <Navigate to={"/post/" + id} />;
  }

  return (
    <form onSubmit={updatePost}>
      <input
        type="title"
        placeholder={"Title"}
        value={title}
        onChange={(ev) => setTitle(ev.target.value)}
      />
      <input
        type="url"
        placeholder={"image URL"}
        value={image}
        onChange={(ev) => setImage(ev.target.value)}
      />
      <Editor value={content} onChange={setContent} />
      <button style={{ marginTop: "5px" }}>Update post</button>
    </form>
  );
}
